import { leadLazyLoad } from 'utils/loadable';

export const ContentNotFound = leadLazyLoad(
  () => import('./ContentNotFoundPage'),
  module => module.ContentNotFoundPage,
);
